import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RedeploymentOrderListComponent } from './redeployment-order-list/redeployment-order-list.component'; 
import { RedeploymentOrderComponent } from './redeployment-order/redeployment-order.component';

import { AuthGuard } from '@core/utilities/auth.guard';
import { RedeploymentAuthorize } from '@core/utilities/redeployment-authorize.guard';
import { Permission } from '@core/literals/permission.literal';
import { Organizations } from '../../shared/literals/shared.literal';

const routes: Routes = [
  {
    path: 'RedeploymentOrder',
    component: RedeploymentOrderListComponent,
    canActivate: [AuthGuard, (RedeploymentAuthorize(Permission.ViewOrders, undefined))]
  },
  {
    path: 'RedeploymentOrder/Detail/:id',
    component: RedeploymentOrderComponent,
    canActivate: [AuthGuard, (RedeploymentAuthorize(Permission.ViewOrders, undefined))]
  }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class RedeploymentOrdersRoutingModule {

}
